import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export const TablePageContainer = memo(({ className, ...restProps }: ComponentProps<'div'>) => (
  <div className={cn('table-page-container relative w-full', className)} {...restProps} />
));

TablePageContainer.displayName = 'TablePageContainer';
